import { HOUSE } from "icons";
import { NavItem } from "../../../components/nav/item";

export function HomeNavigations() {

    return (
        <NavItem
            title="Home"
            icon={HOUSE}
            url="/home"
        />
    );
}
